import { CircleLoader } from "./Circle";
import { DotsWaveLoader } from "./DotsWave";

export const Loader = { Circle: CircleLoader, DotsWave: DotsWaveLoader };
